(ns frontend.view.settings2.surveys.view
  (:require
   [clojure.string :as string]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.survey.survey-question.schema :as survey-question]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.entity :as f-entity]
   [frontend.view.settings2.surveys.db :as db]
   [frontend.view.settings2.surveys.events :as events]
   [frontend.view.settings2.surveys.question-selector :as question-selector]
   [frontend.view.settings2.surveys.question.question-creator :as question-creator]
   [frontend.view.settings2.surveys.sub :as sub]
   [frontend.view.settings2.surveys.survey-block-editor :as survey-block-editor]
   [frontend.view.settings2.surveys.survey-blocks-tab :as survey-blocks-tab]
   [frontend.view.settings2.surveys.survey-type-tab :as survey-type-tab]
   [frontend.view.settings2.surveys.template-editor :as template-editor]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.breadcrumbs.view :as breadcrumbs]
   [ui.components.button.view :as button]
   [ui.components.tab-strip.view :as tab-strip]))

(defn toolbar-buttons
  [selected-tab selected-survey-type-id]
  (case selected-tab
    :entity.type/survey-type
    (cond-> [{:toolbar-button?  true
              :dropdown-action? true
              :ord              0
              :icon             :fa-plus
              :primary-button?  true
              :disabled?        (not (session/has-feature-access? :feature/surveys))
              :tooltip          (when (not (session/has-feature-access? :feature/surveys))
                                  (loc/tr :feature-not-enabled))
              :on-select        (fn [_e]
                                  (f-entity/open-creator! :entity.type/survey-type
                                                          {:on-ok! (fn [{:keys [close-cb!]}]
                                                                     (close-cb!))}))
              :label            (loc/tr :settings.surveys/create-survey-type)}]
      selected-survey-type-id
      (concat
       [{:toolbar-button?  true
         :dropdown-action? true
         :ord              1
         :icon             :fa-plus
         :primary-button?  false
         :on-select        (fn [_e]
                             (f-entity/open-creator! :entity.type/rotation-period
                                                     {:prevent-open-entity-after-create? true
                                                      :on-ok!                            (fn [{:keys [close-cb!]}]
                                                                                          (close-cb!))
                                                      :start-value                       {:common/containing-entity selected-survey-type-id}}))
         :label            "Create Rotation Period"}
        {:toolbar-button?  true
         :dropdown-action? true
         :ord              2
         :icon             :fa-plus
         :primary-button?  false
         :on-select        (fn [_e]
                             (f-entity/open-creator! :entity.type/reminder-rule
                                                     {:prevent-open-entity-after-create? true
                                                      :on-ok!                            (fn [{:keys [close-cb!]}]
                                                                                          (close-cb!))
                                                      :start-value                       {:common/containing-entity selected-survey-type-id}}))
         :label            "Create Reminder Rule"}
        {:toolbar-button?  true
         :dropdown-action? true
         :ord              3
         :icon             :fa-plus
         :primary-button?  false
         :on-select        (fn [_e]
                             (f-entity/open-creator! :entity.type/survey-cycle
                                                     {:prevent-open-entity-after-create? true
                                                      :on-ok!                            (fn [{:keys [close-cb!]}]
                                                                                          (close-cb!))
                                                      :start-value                       {:common/containing-entity selected-survey-type-id}}))
         :label            "Create Survey Cycle"}]))
    :entity.type/survey-block
    [{:toolbar-button?  true
      :dropdown-action? true
      :ord              2
      :icon             :fa-plus
      :primary-button?  true
      :disabled?        (not (session/has-feature-access? :feature/surveys))
      :tooltip          (when (not (session/has-feature-access? :feature/surveys))
                          (loc/tr :feature-not-enabled))
      :on-select        (fn [_e]
                          (f-entity/open-creator! :entity.type/survey-block
                                                  {:on-ok!      (fn [{:keys [close-cb!]}]
                                                                  (close-cb!))
                                                   :start-value {}}))
      :label            (loc/tr :settings.surveys/create-survey-block)}]
    :entity.type/survey-question
    [{:toolbar-button?  true
      :dropdown-action? true
      :ord              2
      :icon             :fa-plus
      :primary-button?  true
      :disabled?        (not (session/has-feature-access? :feature/surveys))
      :tooltip          (when (not (session/has-feature-access? :feature/surveys))
                          (loc/tr :feature-not-enabled))
      :on-select        #(rf/dispatch [::events/start-create-question])
      :label            (loc/tr :settings.surveys/create-survey-question)}]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/surveys)]])

(defn survey-questions-row
  [survey-question]
  [:tr
   {:class-name "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"
    :key        (str "survey-question-row-" (:db/id survey-question))}
   [:td
    (:label survey-question)]
   [:td
    (survey-question/data-type-label loc/tr (:survey-question/data-type survey-question))]
   [:td
    (:survey-question/data-unit survey-question)]
   [:td
    (string/join ", " (:survey-question/keywords survey-question))]
   [:td
    (string/join ", " (map languages/get-label (:languages survey-question)))]
   [:td
    [button/square-secondary-open
     {:tooltip  (loc/tr :edit)
      :on-click #(rf/dispatch [::events/start-question-edit survey-question])}
     [:i.fas.fa-pen]]]])

(defn survey-questions-table
  [survey-questions]
  [:div
   {:class "py-6 flex flex-col gap-4"}
   [:p
    (loc/tr :settings.survey-questions/top-text [(string/lower-case (loc/tr :module/survey))])]

   [:div
    {:class "border border-solid border-base-light-border-paler rounded-lg overflow-x-auto"}
    [:div
     {:class "w-full inline-block"}
     [:table
      {:class "min-w-full divide-y divide-solid divide-base-light-border-paler"}
      [:thead
       [:tr
        {:class "*:whitespace-nowrap *:px-2 *:py-3 *:text-sm *:text-base-light-text"}
        [:th (loc/tr :settings.survey-questions/table-heading-label)]
        [:th (loc/tr :settings.survey-questions/table-heading-data-type)]
        [:th (loc/tr :settings.survey-questions/table-heading-data-unit)]
        [:th (loc/tr :settings.survey-questions/table-heading-keywords)]
        [:th (loc/tr :settings.survey-questions/table-heading-languages)]
        [:th (loc/tr :settings.survey-questions/table-heading-edit)]]]
      [:tbody
       {:class "divide-y divide-solid divide-base-light-border-paler"}
       (->> survey-questions
            (map survey-questions-row)
            (doall))]]]]])

(defn component
  []
  (let [state (r/atom {})]
    (r/create-class
     {:component-did-mount
      (fn [_]
        (rf/dispatch [::events/load-data]))
      :component-will-unmount
      (fn [_]
        (rf/dispatch [::events/clean-up]))
      :reagent-render
      (fn []
        (let [selected-tab @(rf/subscribe [::sub/selected-tab])
              selected-survey-type-id @(rf/subscribe [::sub/selected-survey-type])
              survey-templates @session/survey-templates
              survey-blocks @session/survey-blocks
              survey-templates-by-type (->> survey-templates
                                            (group-by :survey-template/survey-type))
              survey-types (concat (->> @session/survey-types
                                        (remove :common/disabled?)
                                        (mapv (fn [survey-type]
                                                (assoc survey-type
                                                       :survey-type-templates
                                                       (get survey-templates-by-type (:db/id survey-type))))))
                                   (when (get survey-templates-by-type nil)
                                     [{:db/id                 nil
                                       :survey-template/label (loc/tr :survey-template-not-set)
                                       :survey-type-templates (get survey-templates-by-type nil)}]))
              survey-questions @(rf/subscribe [::sub/question-registry])
              block-editor-open? @(rf/subscribe [::sub/block-editor-open?])
              question-selector-open? @(rf/subscribe [::sub/question-selector-open?])
              question-create-open? @(rf/subscribe [::sub/question-create-open?])
              template-editor-open? @(rf/subscribe [::sub/template-editor-open?])]
          [:<>
           [zap-toolbar/view db/state breadcrumbs nil (toolbar-buttons selected-tab selected-survey-type-id)]
           [:div
            {:class "pb-8 h-[calc(100vh-52px-50px)] overflow-y-auto
                 text-base-light-text
                 bg-base-light"}
            [:div
             {:class "px-4 py-4 h-full flex flex-col min-h-0"}
             [tab-strip/view
              {:tabs         [{:value :entity.type/survey-type
                               :label (loc/tr :survey-types-and-templates-tab)}
                              {:value :entity.type/survey-block
                               :label (loc/tr :survey-blocks-tab)}
                              {:value :entity.type/survey-question
                               :label (loc/tr :survey-questions-tab)}]
               :selected-tab selected-tab
               :on-change!   #(rf/dispatch [::events/change-tab %])}]
             (case selected-tab
               :entity.type/survey-type
               [:div
                {:class "flex-1 min-h-0"}
                [survey-type-tab/view state survey-types survey-templates-by-type]]
               :entity.type/survey-block
               [survey-blocks-tab/view state survey-blocks]
               :entity.type/survey-question
               [survey-questions-table survey-questions])]]
           (cond
             question-create-open?
             [question-creator/view]
             question-selector-open?
             [question-selector/view]
             block-editor-open?
             [survey-block-editor/view]
             template-editor-open?
             [template-editor/view])]))})))

(defmethod routing/render-view :settings/surveys
  [_]
  [default-page-layout/view
   [component]])
